var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.click(_vm.brand)}}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.brandLogoImageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }